import { FilterCriteriaParam } from '@models/CommonParam';

export const exploreKeys = {
  segmentStackChart: (filterCriteriaParam: FilterCriteriaParam) =>
    ['exploreSegmentsStackedChart', filterCriteriaParam] as const,
};
